import React from 'react';

/** Shared workspace frame. Session, navigation and chat are supplied by the entry. */
export default function AppShellLayout({ sidebar, header, dock, bubble, captureViewport, banner, children }) {
  return <div className={`flex bg-gray-100 ${captureViewport ? 'overflow-hidden' : 'h-screen'}`} data-testid="app-shell"
    style={captureViewport ? { width: `${captureViewport.width}px`, height: `${captureViewport.height}px` } : undefined}>
    {sidebar}
    <div className="flex min-w-0 flex-1 flex-col overflow-hidden">
      {/* Above the page and its chat: whose screen this is. */}
      {banner}
      <div className="flex min-h-0 min-w-0 flex-1 overflow-hidden">
        <div className="flex min-h-0 min-w-0 flex-1 flex-col overflow-auto transition-all duration-300 scrollbar-hide" style={{ msOverflowStyle: 'none', scrollbarWidth: 'none' }}>
          <style>{'.scrollbar-hide::-webkit-scrollbar { display: none; }'}</style>
          {header}
          <main className="min-h-0 flex-1" data-workspace-tour="data" data-testid="app-shell-main">{children}</main>
        </div>
        {dock}
      </div>
    </div>
    {bubble}
  </div>;
}
